import * as React from 'react';

import { IBrandScreenProps } from './types';

import * as s from './BrandScreen.scss';

const BrandScreenComponent = ({
	id,
	title,
	children,
}: React.PropsWithChildren<IBrandScreenProps>) => {
	return (
		<div
			id={id}
			className={s.block}
		>
			{!!title &&
				<div className={s.title}>
					{title}
				</div>
			}

			{children}
		</div>
	);
};

export const BrandScreen = React.memo(BrandScreenComponent, () => true);
